__turbopack_context__.v({
  "activeTab": "PremiumToolkit-module__2Vv91W__activeTab",
  "container": "PremiumToolkit-module__2Vv91W__container",
  "coverLetterSection": "PremiumToolkit-module__2Vv91W__coverLetterSection",
  "coverLetterTips": "PremiumToolkit-module__2Vv91W__coverLetterTips",
  "employerCard": "PremiumToolkit-module__2Vv91W__employerCard",
  "employerHeader": "PremiumToolkit-module__2Vv91W__employerHeader",
  "employerIndustry": "PremiumToolkit-module__2Vv91W__employerIndustry",
  "employerLink": "PremiumToolkit-module__2Vv91W__employerLink",
  "employerName": "PremiumToolkit-module__2Vv91W__employerName",
  "employerNotes": "PremiumToolkit-module__2Vv91W__employerNotes",
  "employerType": "PremiumToolkit-module__2Vv91W__employerType",
  "employersList": "PremiumToolkit-module__2Vv91W__employersList",
  "exampleBox": "PremiumToolkit-module__2Vv91W__exampleBox",
  "exampleLabel": "PremiumToolkit-module__2Vv91W__exampleLabel",
  "exampleText": "PremiumToolkit-module__2Vv91W__exampleText",
  "header": "PremiumToolkit-module__2Vv91W__header",
  "icon": "PremiumToolkit-module__2Vv91W__icon",
  "jobBoardLinks": "PremiumToolkit-module__2Vv91W__jobBoardLinks",
  "keywordTag": "PremiumToolkit-module__2Vv91W__keywordTag",
  "keywordTags": "PremiumToolkit-module__2Vv91W__keywordTags",
  "keywordsIntro": "PremiumToolkit-module__2Vv91W__keywordsIntro",
  "keywordsSection": "PremiumToolkit-module__2Vv91W__keywordsSection",
  "linkedinTips": "PremiumToolkit-module__2Vv91W__linkedinTips",
  "noEmployers": "PremiumToolkit-module__2Vv91W__noEmployers",
  "questionCard": "PremiumToolkit-module__2Vv91W__questionCard",
  "questionContent": "PremiumToolkit-module__2Vv91W__questionContent",
  "questionNumber": "PremiumToolkit-module__2Vv91W__questionNumber",
  "questionText": "PremiumToolkit-module__2Vv91W__questionText",
  "questionsList": "PremiumToolkit-module__2Vv91W__questionsList",
  "salaryTipCard": "PremiumToolkit-module__2Vv91W__salaryTipCard",
  "sampleAnswer": "PremiumToolkit-module__2Vv91W__sampleAnswer",
  "sampleLabel": "PremiumToolkit-module__2Vv91W__sampleLabel",
  "sampleText": "PremiumToolkit-module__2Vv91W__sampleText",
  "sectionIntro": "PremiumToolkit-module__2Vv91W__sectionIntro",
  "subSectionTitle": "PremiumToolkit-module__2Vv91W__subSectionTitle",
  "tab": "PremiumToolkit-module__2Vv91W__tab",
  "tabContent": "PremiumToolkit-module__2Vv91W__tabContent",
  "tabIcon": "PremiumToolkit-module__2Vv91W__tabIcon",
  "tabLabel": "PremiumToolkit-module__2Vv91W__tabLabel",
  "tabNav": "PremiumToolkit-module__2Vv91W__tabNav",
  "tipBox": "PremiumToolkit-module__2Vv91W__tipBox",
  "tipContent": "PremiumToolkit-module__2Vv91W__tipContent",
  "tipDescription": "PremiumToolkit-module__2Vv91W__tipDescription",
  "tipLabel": "PremiumToolkit-module__2Vv91W__tipLabel",
  "tipNumber": "PremiumToolkit-module__2Vv91W__tipNumber",
  "tipText": "PremiumToolkit-module__2Vv91W__tipText",
  "tipTitle": "PremiumToolkit-module__2Vv91W__tipTitle",
  "tipsList": "PremiumToolkit-module__2Vv91W__tipsList",
  "typeContractor": "PremiumToolkit-module__2Vv91W__typeContractor",
  "typeFortune500": "PremiumToolkit-module__2Vv91W__typeFortune500",
  "typeGovernment": "PremiumToolkit-module__2Vv91W__typeGovernment",
  "typeHealthcareSystem": "PremiumToolkit-module__2Vv91W__typeHealthcareSystem",
  "typeMid-size": "PremiumToolkit-module__2Vv91W__typeMid-size",
  "typeStartup": "PremiumToolkit-module__2Vv91W__typeStartup",
});
